import type { ReactNode } from 'react';
import type { PriorEducationStatus } from '@teachur/http-client';

const SITUATION_INTRO: Record<PriorEducationStatus, string> = {
  no_credits:
    "You're starting with a clean slate, and that's a great place to begin. We'll build your Associate of Arts with you from the ground up.",
  some_credits_no_associate:
    "You've already got a head start. We'll do our best to put your existing credits to work toward your Associate of Arts.",
  many_credits_no_associate:
    "You've come a long way already. We'll look for the smoothest path that carries your credits toward your associate and bachelor's.",
  associate_only:
    "Congrats on finishing your associate degree. That's a big milestone, and it gives you a strong head start toward your bachelor's.",
  associate_plus_credits:
    "You've done a lot already: an associate degree plus extra credits. We'll see how much of it we can carry forward for you.",
  bachelor_or_higher:
    'With a degree already behind you, most of the heavy lifting is done. Just a few steps remain.',
};

const PLAN_NEXT_STEPS: ReactNode = (
  <>
    Once you're done here, upload your transcripts or enter your coursework manually to receive an
    unofficial transfer credit estimate. Be sure to also{' '}
    <a
      href="https://newlane.edu/transferring-credits-toward-an-aa-or-ba-degree/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-(--primary-O1000)! font-semibold"
    >
      request that your previous institutions send your official transcripts directly to Newlane
    </a>
    . Once we receive your official transcripts, our transfer credit evaluation team will review
    your academic record and finalize your official transfer evaluation. In the meantime, you can
    use your unofficial estimate to help plan your coursework and get started at Newlane.
  </>
);

export const buildPlanMessage = (
  status: PriorEducationStatus | null
): { intro: string; nextSteps: ReactNode } | null => {
  if (!status) return null;

  return {
    intro: SITUATION_INTRO[status],
    nextSteps: PLAN_NEXT_STEPS,
  };
};
